import React, { Component, useState } from "react";
import { Chart } from "react-google-charts";

const PieChart = ({ title,chartType, d }) => {
  return (
    <Chart
      width={"500px"}
      height={"300px"}
      chartType={chartType}
      data={d}
      options={{
        title: title,
      }}
      rootProps={{ "data-testid": "1" }}
    />
  );
};

export default PieChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/pieChart.jsx